<template>
  <div class="fixed-bottom bg-primary" v-if="isPlaying">
    <span class="PlayIconSound py-2 px-2 position-absolute mt-8" @click="CloseSoundCloud">
      <i class="fas fa-times-circle text-primary fa-3x" style="crusor:pointer;  background-color: white;
                border-radius: 50%;"></i>
    </span>
    <section id="media-player-wrapper">
      <div class="row">
        <div class="col-md-12">
          <div class="card p-2">
            <!-- AUDIO -->
            <h6 class="card-title">Audio</h6>
            <audio style="margin-top:3rem !important;width: 117rem !important;" id="plyr-audio-player"
              class="audio-player" autoplay controls>
              <source src="https://soundcloud.com/popeshenoudagec/10-10-2007a" type="audio/mp3" />
              <source src="https://soundcloud.com/popeshenoudagec/10-10-2007a" type="audio/mpeg" />
            </audio>
            <!-- AUDIO END -->
          </div>
        </div>
      </div>
    </section>



    <!-- <iframe
      width="100%"
      height="200"
      scrolling="no"
      frameborder="no"
      allow="autoplay"
      :src="
        `https://w.soundcloud.com/player/?url=&auto_play=true&sharing=false&show_user=false&show_artwork=false&show_comments=false`
      "
    ></iframe> -->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    URL() {
      return this.$store.state.URL;
    },
    isPlaying() {
      return this.$store.state.isPlaying;
    },
  },
  methods: {
    CloseSoundCloud() {
      this.$store.commit("UpdateIsPlaying");
    },
  },
  created() { },
};
</script>
<style>
.fixed-bottom {
  position: fixed;
  height: 157px;
  bottom: 0;
  width: 100%;
  /* padding-right: 20px !important;
  padding-left: 20px !important; */
}

.PlayIconSound {
  top: 0 !important;
  right: 20px;
  z-index: 5000;
}

.card-body {

  padding: 1.25rem !important;
  color: null !important;

}

.card-title {
  margin-bottom: .75rem;
}

.audio-player:focus {
  outline: 0;
}

.plyr__controls {
  justify-content: flex-start;
}

.plyr__progress {
  flex-grow: 1;
}

.card {
  width: 500rem !important;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, .125);
}

.card>hr {
  margin-right: 0;
  margin-left: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: 1.25rem;
  color: #fff;
}

.card-title {
  margin-bottom: 1.5rem;
}

.card-subtitle {
  margin-top: -0.75rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}</style>
